import { render, staticRenderFns } from "./MarqueFilter.vue?vue&type=template&id=4126477a&"
import script from "./MarqueFilter.vue?vue&type=script&lang=js&"
export * from "./MarqueFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports